import React, { useState } from 'react';
import axios from 'axios';
import { APP_API_URL } from '../../utils';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';

export default function Delete({ open, onClose, category, refreshData }) {
  const [isLoading, setLoading] = useState(false);

  if (!open || !category) return null;

  const handleDelete = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.delete(`${APP_API_URL}/categories/${category.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        await Swal.fire({
          icon: 'success',
          title: 'Supprimé',
          text: 'La sous-catégorie a été supprimée avec succès.',
          timer: 2000,
          showConfirmButton: false,
        });
        onClose();
        refreshData();
      }
    } catch (error) {
      console.error('Erreur lors de la suppression', error);
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: 'Une erreur est survenue lors de la suppression. Veuillez réessayer.',
      });
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = () => {
    Swal.fire({
      title: 'Êtes-vous sûr ?',
      text: 'Cette action est irréversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, supprimer',
      cancelButtonText: 'Annuler',
      confirmButtonColor: '#ff4b4b',
    }).then((result) => {
      if (result.isConfirmed) handleDelete();
    });
  };

  return (
    <DuoModal
      title="Supprimer une sous-catégorie"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={onClose} disabled={isLoading}>
            Annuler
          </button>
          <button type="button" className="duo-btn duo-btn--danger" onClick={confirmDelete} disabled={isLoading}>
            {isLoading ? 'Suppression...' : 'Supprimer'}
          </button>
        </>
      }
    >
      <div className="duo-modal__hero">
        <i className="bi bi-exclamation-triangle-fill duo-modal__hero-icon" style={{ color: '#ff4b4b' }} aria-hidden />
        <p className="duo-modal__hero-text">
          Voulez-vous vraiment supprimer <strong>{category.nom}</strong> ?
        </p>
      </div>
    </DuoModal>
  );
}
